import { render, staticRenderFns } from "./AddUpdateTopic.vue?vue&type=template&id=759e94c6&"
import script from "./AddUpdateTopic.vue?vue&type=script&lang=js&"
export * from "./AddUpdateTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports